import Backbone from 'backbone';

import OrderDecisionView from '../views/OrderDecisionView/OrderDecisionView';
import GetCustomerOrderDecision from '../services/GetCustomerOrderDecision';

export default async function loadOrderDecisionView(orderDetails) {
  const decisionData = await GetCustomerOrderDecision(orderDetails.orderId);
  decisionData.decisionStatus = parseInt(decisionData.decisionStatus);

  return new OrderDecisionView({
    model: new Backbone.Model({
      decisionData,
      orderDetails,
      editable: orderDetails.editable
    })
  });
}
